<template>
    <v-alert class="mx-2" border="start" border-color="primary-dark" elevation="1" v-if="teams_on_error.length > 0">
        <div class="mb-2">Les modalités d'inscription ne sont pas respectées:</div>
        <div v-for="(team, index) in teams_on_error" :key="index">
            <div class="text-h6"><u>Equipe {{ team.equipe_name }} sur {{ team.course_name }}</u></div>
            <ul>
                <li v-for="(error, index_error) in team.errors" :key="index_error">
                    {{ error }}
                </li>
            </ul>
        </div>
    </v-alert>

</template>

<script>
export default {
    props: ["validation"],
    name: 'PopupErrorFFR',
    // Your component's JavaScript logic goes here
    computed: {

        teams_on_error() {
            let teams = [];
            if (!this.validation || !this.validation.details) [];
            for (let i = 0; i < this.validation.details.length; i++) {
                if (!this.validation.details[i].status) {
                    teams.push(this.validation.details[i]);
                }

            }
            return teams;
        }
    },
    data() {

        return {
            dialog: true,

        }
    },
    created() {


    }
}
</script>

<style scoped>
/* Your component's CSS styles go here */
</style>